export default {
  auth: {
    cognito: {
      userPoolId: 'us-west-2_nWmUV9bO3',
      userPoolWebClientId: '6q7p08to3ql6g0hbn691utbi7o',
      region: 'us-west-2'
    }
  }
};
